import React from 'react';

import values                          from '../../../../values';
import Context                         from '../../../../context';
import FactorsNeedpay2CompanyComponent from './components';

import {useTranslation} from 'react-i18next';
import {
  Pagination,
  ResponsiveView,
  BreadCrumb,
  TableHeader,
  CustomModal,
  TableLoading,
  CustomButton2,
} from '../../../../components';

import './index.sass';

type Props = {
  resultData   : any;
  resultAllDate: any;
}

const FactorsNeedPay2CompanyScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    request,
    showModal,
    setRequest,
    setShowModal,
    payCompanyFactors,
  } = React.useContext(Context.FactorsNeedPay2CompanyScreenContext);

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleOnClickShowModal(): void {
    setShowModal(showModal === 'SHOW_PRICE' ? 'NONE' : 'SHOW_PRICE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id="financial-group-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb/>
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <FactorsNeedpay2CompanyComponent.Filter />
          <ResponsiveView.Column small={10}>
            <CustomButton2 onClick={handleOnClickShowModal} title={'فاکتور های تسویه نشده'} type={'primary'} />
          </ResponsiveView.Column>
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.COMPANY_FINANCIAL_FACTORS_COMPANY.map((item) => t(item))}/>
            {props.resultData?.status === "loading" ? (
              <TableLoading/>
            ) : (
              <FactorsNeedpay2CompanyComponent.Body data={props.resultData?.data?.result?.docs}/>
            )}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.resultData?.status === "success" &&
        props.resultData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={props?.resultData?.data?.result?.page}
              totalPages={props.resultData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequest({...request, page: page,})}
            />
          </div>
        )
      }
      <CustomModal open={showModal === 'SHOW_PRICE'} onClose={handleOnClickShowModal} overlayClose>
        <ResponsiveView.Container>
          <ResponsiveView.Row>
            <ResponsiveView.Column small={4}>
              {`تعداد فاکتور‌ها : ${props?.resultAllDate?.data?.result?.sumOfFactors}`}
            </ResponsiveView.Column>
            <ResponsiveView.Column small={4}>
              {` مبلغ کل : ${props?.resultAllDate?.data?.result?.sumOfFactorsPrice}`}
            </ResponsiveView.Column>
            <ResponsiveView.Column small={4}>
              {` سهم شرکت و ادمین : ${props?.resultAllDate?.data?.result?.sumOfSharesPrice}`}
            </ResponsiveView.Column>
          </ResponsiveView.Row>
          <br />
          <ResponsiveView.Row>
            <ResponsiveView.Column small={4}>
              <CustomButton2 title={'تسویه'} onClick={payCompanyFactors} />
            </ResponsiveView.Column>
          </ResponsiveView.Row>
          <ResponsiveView.Row>
            <ResponsiveView.Column id="table-content-wrapper-company-factor" className="table-content-wrapper">
              <table>
                <TableHeader headers={values.tableHeaders.COMPANY_FINANCIAL_FACTORS_COMPANY.map((item) => t(item))}/>
                {props.resultData?.status === "loading" ? (
                  <TableLoading/>
                ) : (
                  <FactorsNeedpay2CompanyComponent.BodyAll data={props.resultAllDate?.data?.result?.factorList}/>
                )}
              </table>
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default FactorsNeedPay2CompanyScreen;
